<template>
  <div
    :style="{backgroundColor:final_ui_color,
             borderColor:color
    }"
    class="flex py-0.5 px-2 truncate border rounded-full"
  >
    <span :title="final_name" class="truncate text-xs " >
      {{text}}
    </span>
  </div>
</template>



<script>
import {changeAlpha} from '@/utils/common';

export default {
  components: {},
  props: {
    text: {
      type: String,
      default: 'No name provided'
    },
    color: {
      type: String,
      default: '#DEDEDE'
    }
  },
  data() {
    return {
      final_name:''
    }
  },
  computed:{
    final_ui_color(){
      if(this.color){
        return changeAlpha(this.color,0.3)
      }
      else{
        return 'FFFFFF'
      }
    }
  },
  methods: {

  },
  mounted() {

  }
}

</script>
<style scoped>

</style>
